import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './ErrorBoundary.scss';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.error(error, info);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-icon" />
          <div className="error-boundary-body">
            <h2 className="error-boundary-title">Something went wrong</h2>
            <p className="error-boundary-message">
              An unexpected error occurred while loading this section.
              <br />
              Try refreshing the page — if the issue continues, our support team is ready to help.
            </p>
            <div className="error-boundary-actions">
              <button
                className="error-boundary-btn error-boundary-btn--secondary"
                onClick={() => window.location.reload()}
                type="button"
              >
                Refresh Page
              </button>
              <Link className="error-boundary-btn error-boundary-btn--primary" to="/contact-us">
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return children;
  }
}
